import { render } from "./MassActionInterface.vue?vue&type=template&id=6ef94eb0"
import script from "./MassActionInterface.vue?vue&type=script&lang=js"
export * from "./MassActionInterface.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__